import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import InteriorRoomsDisplay from 'formiojs/components/editgrid/editForm/EditGrid.edit.display';
import InteriorRoomsValidation from 'formiojs/components/editgrid/editForm/EditGrid.edit.validation';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: InteriorRoomsDisplay,
    },
    {
      key: 'data',
      ignore: true,
    },
    {
      key: 'validation',
      components: InteriorRoomsValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip:
              'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
